export default __webpack_public_path__ + "static/media/x-circle-filled.45abb283.svg";